import { render, staticRenderFns } from "./ResetView.vue?vue&type=template&id=12854528&scoped=true&"
import script from "./ResetView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ResetView.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ResetView.vue?vue&type=style&index=0&id=12854528&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12854528",
  null
  
)

export default component.exports